<template>
  <Loading v-if="!skeleton.storeLoaded" page="store" />
  <div
    v-show="skeleton.storeLoaded"
    :class="{ 'fade-in': skeleton.storeLoaded }"
  >
    <header-middle />
    <router-view />
    <footer-template />
  </div>
</template>
<script setup>
import Loading from "../section/item/loading.vue";
import HeaderMiddle from "../section/header/header.vue";
import FooterTemplate from "../section/footer/footer.vue";
import { useSkeleton } from "@/store/skeleton";
const skeleton = useSkeleton();
</script>
